import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';

import { Subscription } from 'rxjs';

import { MensagensService } from '../../constantes/mensagens.service';
import { ObservadorSharedService } from '../services/observador-shared.service';

import { InformacaoDialog } from '../models/informacaoDialog.model';

import { ConfiguracaoDialog } from './configuracao';

import { isNullOrUndefined } from '../../util/is-null-or-undefined.util';

@Component({
  selector: 'app-dialog',
  standalone: false,
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
})
export class DialogComponent implements OnInit, OnChanges, OnDestroy {
  @Input() titulo: string;
  @Input() subTitulo: string;
  @Input() mensagem: string;
  @Input() identificacaoDialog: string;
  @Input() informacaoDialog: InformacaoDialog;
  @Input() configuracaoBotoes: Array<ConfiguracaoDialog>;
  @Input() gaLabelCancelar: string;
  @Input() gaLabelSalvar: string;
  @Input() gaLabelRemover: string;
  @Input() gaAction: string;
  @Input() gaLabelFechar: string;

  @Output() confirmou = new EventEmitter<ConfiguracaoDialog>();

  valorInput = '';
  loadingClasse = 'hide';

  botaoCancelar: ConfiguracaoDialog;
  botaoOk: ConfiguracaoDialog;
  botaoRemover: ConfiguracaoDialog;
  botaoFechar: ConfiguracaoDialog;
  botaoSalvar: ConfiguracaoDialog;
  subscriptionDialog: Subscription;

  mensagemFeedbackBotaoSalvar: string;
  mensagemFeedbackInput: string;
  labelInputDialog: string;

  exibirCabecalhoTabela: boolean;
  exibirMensagemSimplesTabela: boolean;
  exibirMensagemCompostaTabela: boolean;
  exibirInputName: boolean;
  exibirTabela: boolean;

  constructor(private observadorShared: ObservadorSharedService) {
    if (this.observadorShared.subjectInformacaoDialog !== null) {
      this.subscriptionDialog =
        this.observadorShared.subjectInformacaoDialog.subscribe(
          (informacaoDialog) => {
            this.informacaoDialog = informacaoDialog;
            this.preencherTitulos();
          }
        );
    }

    if (
      !isNullOrUndefined(
        this.observadorShared.subjectMensagemFeedBackInputDialog
      )
    ) {
      this.observadorShared.subjectMensagemFeedBackInputDialog.subscribe(
        (mensagem) => {
          this.esconderBotoes(false);
          this.mensagemFeedbackInput = mensagem;
        }
      );
    }
  }

  ngOnInit() {
    // Bloqueia a scroll de fundo da pagina
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('modal-open');

    this.mensagemFeedbackBotaoSalvar =
      MensagensService.mensagens.relatorios.salvarConsultas.mensagemFeedbackBotaoSalvar;
    this.labelInputDialog =
      MensagensService.mensagens.relatorios.salvarConsultas.labelinputPopupFeedback;
    this.valorInput = '';
    this.preencherTitulos();
    this.inicializaControles();
    this.converterMensagensChaveValor();
    this.configuraBotoes();
    this.definirRegrasExibicaoConteudoTabela();
  }

  preencherTitulos() {
    if (!isNullOrUndefined(this.informacaoDialog)) {
      this.titulo = this.informacaoDialog.titulo;
      this.subTitulo = this.informacaoDialog.subTitulo;
    }
  }

  ngOnChanges(mudanca: SimpleChanges) {
    this.inicializaControles();
    // verifica se propriedades estão definidas
    if (mudanca.titulo && mudanca.mensagem) {
      this.titulo = mudanca.titulo.currentValue;
      this.mensagem = mudanca.mensagem.currentValue;
    }
    if (mudanca.informacaoDialog) {
      this.informacaoDialog = mudanca.informacaoDialog.currentValue;
    }
    this.configuraBotoes();
    this.converterMensagensChaveValor();
    this.definirRegrasExibicaoConteudoTabela();
  }

  emitirClique(botao: ConfiguracaoDialog) {
    if (botao.texto === 'SALVAR') {
      this.esconderBotoes(true);
    }
    this.confirmou.emit(botao);
  }

  ngOnDestroy() {
    // Desbloqueia a scroll de fundo da pagina
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('modal-open');

    if (
      this.subscriptionDialog !== null &&
      this.subscriptionDialog !== undefined
    ) {
      this.subscriptionDialog.unsubscribe();
    }
  }

  validaPreenchimentoInput(event: Event): void {
    this.botaoSalvar.habilitado = false;
    if (event != null) {
      const value = (<HTMLInputElement>event.target).value;
      this.valorInput = value.trim();
      this.botaoSalvar.habilitado = this.valorInput.length > 0;
      if (!isNullOrUndefined(this.observadorShared.subjectValorInputDialog)) {
        this.observadorShared.subjectValorInputDialog.next(this.valorInput);
      }
    }
  }

  /**
   * Define a classe para exibição ou ocultação dos botões Salvar Consulta e Download
   *
   * @param param
   */
  esconderBotoes(param: boolean) {
    this.loadingClasse = !param ? 'hide' : 'show';
    this.botaoSalvar.mostrar = !param;
    this.botaoCancelar.mostrar = !param;
  }

  definirRegrasExibicaoConteudoTabela() {
    if (!isNullOrUndefined(this.informacaoDialog)) {
      this.exibirCabecalhoTabela = !isNullOrUndefined(
        this.informacaoDialog.cabecalhos
      );
      this.exibirMensagemSimplesTabela =
        !isNullOrUndefined(this.informacaoDialog.mensagensSimples) &&
        this.informacaoDialog.mensagensSimples.length > 0;
      this.exibirMensagemCompostaTabela =
        !this.exibirMensagemSimplesTabela &&
        !isNullOrUndefined(this.informacaoDialog.mensagens) &&
        this.informacaoDialog.mensagens.length > 0;
      this.exibirTabela =
        this.exibirMensagemCompostaTabela || this.exibirMensagemSimplesTabela;
      this.exibirInputName = !isNullOrUndefined(
        this.informacaoDialog.exibirInput
      )
        ? this.informacaoDialog.exibirInput
        : false;
    }
  }

  private configuraBotoes(): void {
    if (this.configuracaoBotoes) {
      // ordena de forma crescente
      this.configuracaoBotoes.forEach((config) => {
        if (config.mostrar) {
          switch (config.texto) {
            case 'OK':
            case 'SIM':
              this.botaoOk.texto = config.texto;
              this.botaoOk.eConfirmacao = config.eConfirmacao;
              this.botaoOk.mostrar = config.mostrar;
              break;
            case 'REMOVER':
              this.botaoRemover.texto = config.texto;
              this.botaoRemover.eConfirmacao = config.eConfirmacao;
              this.botaoRemover.mostrar = config.mostrar;
              break;
            case 'CANCELAR':
            case 'NÃO':
              this.botaoCancelar.texto = config.texto;
              this.botaoCancelar.eConfirmacao = config.eConfirmacao;
              this.botaoCancelar.mostrar = config.mostrar;
              break;
            case 'FECHAR':
              this.botaoFechar.texto = config.texto;
              this.botaoFechar.eConfirmacao = config.eConfirmacao;
              this.botaoFechar.mostrar = config.mostrar;
              break;
            case 'SALVAR':
              this.botaoSalvar.texto = config.texto;
              this.botaoSalvar.eConfirmacao = config.eConfirmacao;
              this.botaoSalvar.mostrar = config.mostrar;
              break;
          }
        }
      });
    }
  }

  private inicializaControles(): void {
    this.botaoOk = {} as ConfiguracaoDialog;
    this.botaoOk.mostrar = false;
    this.botaoOk.habilitado = true;
    this.botaoCancelar = {} as ConfiguracaoDialog;
    this.botaoCancelar.mostrar = false;
    this.botaoCancelar.habilitado = true;
    this.botaoRemover = {} as ConfiguracaoDialog;
    this.botaoRemover.mostrar = false;
    this.botaoRemover.habilitado = true;
    this.botaoFechar = {} as ConfiguracaoDialog;
    this.botaoFechar.mostrar = false;
    this.botaoFechar.habilitado = true;
    this.botaoSalvar = {} as ConfiguracaoDialog;
    this.botaoSalvar.mostrar = false;
    this.botaoSalvar.habilitado = false;
  }

  /**
   * Método responsável por converter as mensagens de chave e valor para um modelo de dados padrão
   */
  converterMensagensChaveValor() {
    if (
      this.informacaoDialog &&
      this.informacaoDialog.mensagensChaveValor &&
      this.informacaoDialog.mensagensChaveValor.length > 0
    ) {
      this.informacaoDialog.mensagens = [];
      this.informacaoDialog.mensagensChaveValor.forEach((mensagem) => {
        this.informacaoDialog.mensagens.push(mensagem);
      });
    }
  }

  listarValoresMensagem(mensagem: any): string[] {
    if (mensagem) {
      const valores = [];
      Object.keys(mensagem).forEach((chave) => {
        valores.push(mensagem[chave]);
      });
      return valores;
    }
  }
}
